/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as React from "react";
import { connect } from "react-redux";
import * as moment from "moment";

import { Authorize } from "reauthorize";
import { Dropdown, Tab } from "semantic-ui-react";

import { toast } from "@teamprevent/common/toasts";
import { CaseType } from "@teamprevent/common/model";
import { Appointment } from "@teamprevent/common/calendar";
import { AppointmentAndParent, Clinic } from "@teamprevent/common/calendar/models";
import { ClinicLocationTypeName } from "@teamprevent/common/appointment/models";

import { Calendar } from "../../calendar";
import {
    bookIntoClinic,
    showOnlyClinicsWithInsufficientCliniciansChanged,
    clinicTypeChanged,
    clinicLocationTypeChanged,
    focusDateChanged,
    selectedRoomIdsChanged,
    selectedUserIdsChanged,
    chooseAndBook,
    bookIntoMobileClinic,
    loadBookAppointmentTasks
} from "../actions";
import {
    BookAppointmentTaskListModel,
    ApplicationState,
    CalendarFiltersState,
    FaceToFaceTaskTypesBookableIntoMobileClinic,
    BookAppointmentFiltersModel
} from "../models";
import { TriageList } from "../../triage/components/triageList";
import { TeamListModel } from "../../teams";
import { AppointmentModal } from "../../calendar/components/AppointmentModal";
import { TaskActionSubRoutes } from "../../task/taskActions/TaskActionSubRoutes";
import { ALL_CUSTOMERS } from "../../calendar/clinics/models";
import { CreateTimeNoteModal } from "../../calendar/timeNotes/components/CreateTimeNoteModal";
import { PartialCustomerListModel, loadCustomers } from "../../crud/customer";
import { getCustomerNamesForBookableCustomerIds } from "../../crud/customer/model";
import { ADMIN_ROLES } from "../../auth";
import { MergedAppointmentModal } from "../appointmentMerging/MergedAppointmentModal";

import { BookAppointmentFilters } from "./BookAppointmentsFilters";
import { BookAdHocAppointment } from "./BookAdHocAppointment";
import { BookClinicAppointment } from "./BookClinicAppointment";
import { BookAppointmentsCards } from "./BookAppointmentsCards";
import { LocationTypeSelectorModal } from "./LocationTypeSelectorModal";
import { BookMultipleAppointments } from "./BookMultipleAppointments";

import { push, Fragment, Location, Link } from "redux-little-router";

interface StateProps {
    bookAppointmentTasks: BookAppointmentTaskListModel[];
    path: string;
    calendarFilters: CalendarFiltersState;
    bookTaskId: string;
    customers: PartialCustomerListModel[];
    teams: TeamListModel[];
}

interface DispatchProps {
    bookIntoClinic: (bookTaskId: string, appointment: AppointmentAndParent, appointmentLocationType: ClinicLocationTypeName) => void;
    bookIntoMobileClinic: (bookTaskId: string, appointment: Appointment) => void;
    bookIntoOpenClinic: (bookTaskId: string, appointment: Appointment) => void;
    bookAdHocAppointment: (bookTaskId: string, time: moment.Moment, clinicianId?: string) => void;
    createTimeNoteAppointment: (time: moment.Moment, clinicianId: string) => void;
    selectAppointment: (appointment: Appointment) => void;
    closeAppointment: () => void;
    showOnlyClinicsWithInsufficientCliniciansChanged: (showOnlyClinicsWithInsufficientClinicians: boolean) => void;
    clinicTypeChanged: (clinicType: string) => void;
    clinicLocationTypeChanged: (clinicLocationType: string) => void;
    dateChanged: (date: moment.Moment) => void;
    selectedUserIdsChanged: (userIds: string[]) => void;
    selectedRoomIdsChanged: (roomIds: string[]) => void;
    chooseAndBook: (task: BookAppointmentTaskListModel) => void;
    loadBookAppointmentTasks: (
        customerIds: string[] | undefined,
        taskTypes: string[] | undefined,
        caseTypes: CaseType[] | undefined,
        bookTaskId: string,
        teamIds: string[] | undefined
    ) => Promise<void>;
    loadCustomers: () => Promise<void>;
}

type CalendarView = "clinics" | "roomsAndClinicians";

interface LocationTypeSelectorModalState {
    open: boolean;
    bookAppointmentTask: BookAppointmentTaskListModel;
    appointment: AppointmentAndParent;
}

interface State {
    calendarView: CalendarView;
    locationTypeSelectorModal?: LocationTypeSelectorModalState;
    filters?: BookAppointmentFiltersModel;
}

type AllProps = StateProps & DispatchProps;

interface PropsFromDispatch {
    bookIntoClinic: (bookTask: BookAppointmentTaskListModel, appointment: AppointmentAndParent, locationType: ClinicLocationTypeName) => void;
    bookIntoMobileClinic: (bookTask: BookAppointmentTaskListModel, appointment: Appointment) => void;
    bookIntoOpenClinic: (path: string, bookTask: BookAppointmentTaskListModel, appointment: Appointment) => void;
    bookAdHocAppointment: (path: string, bookTaskId: string, time: moment.Moment, clinicianId: string) => void;
    createTimeNoteAppointment: (path: string, time: moment.Moment, clinicianId: string) => void;
    selectAppointment: (appointment: Appointment) => void;
    closeAppointment: () => void;
    showOnlyClinicsWithInsufficientCliniciansChanged: (showOnlyClinicsWithInsufficientClinicians: boolean) => void;
    clinicTypeChanged: (clinicType: string) => void;
    clinicLocationTypeChanged: (clinicLocationType: string) => void;
    dateChanged: (date: moment.Moment) => void;
    selectedUserIdsChanged: (userIds: string[]) => void;
    selectedRoomIdsChanged: (roomIds: string[]) => void;
    chooseAndBook: (task: BookAppointmentTaskListModel) => void;
    loadBookAppointmentTasks: (customerIds: string[], taskTypes: string[], caseTypes: CaseType[], taskId: string, teamIds: string[]) => Promise<void>;
    loadCustomers: () => Promise<void>;
}

class BookAppointmentsListUnconnected extends React.Component<AllProps, State> {
    constructor(props: AllProps) {
        super(props);
        this.state = { calendarView: "clinics" };
        this.onAppointmentDrop = this.onAppointmentDrop.bind(this);
        this.onAppointmentClick = this.onAppointmentClick.bind(this);
        this.onAppointmentModalClose = this.onAppointmentModalClose.bind(this);
        this.onFiltersChanged = this.onFiltersChanged.bind(this);
    }

    public componentDidMount = () => {
        this.loadTasks();
        this.props.loadCustomers();
    };

    public componentDidUpdate = (prevProps: AllProps) => {
        if (this.props.bookTaskId !== prevProps.bookTaskId) {
            this.loadTasks();
        }
    };

    private loadTasks = () => {
        const teamIds = this.state.filters?.teams;
        const selectedCustomers = this.state.filters?.customers;
        this.props.loadBookAppointmentTasks(selectedCustomers, this.state.filters?.taskTypes, this.state.filters?.products, this.props.bookTaskId, teamIds);
    };

    private onSubmitLocationTypeSelectorModal = (location: ClinicLocationTypeName) => {
        this.props.bookIntoClinic(this.state.locationTypeSelectorModal.bookAppointmentTask.id, this.state.locationTypeSelectorModal.appointment, location);
        this.setState({ locationTypeSelectorModal: null });
    };

    public render() {
        const selectedFilters = this.state.filters;
        const selectedTeams = this.props.teams.filter(t => selectedFilters?.teams.indexOf(t.id) !== -1);
        const filteredBookTasks = this.props.bookAppointmentTasks.filter(bookTask =>
            (!selectedTeams.length || selectedTeams.find(team => !!team.customers.find(customer => customer.id === bookTask.customer.id))) &&
            (!selectedFilters?.products.length || selectedFilters?.products.indexOf(bookTask.caseType) !== -1) &&
            (!selectedFilters?.taskTypes.length || selectedFilters?.taskTypes.find(taskType => bookTask.type === taskType)) &&
            (!selectedFilters?.customers.length || selectedFilters?.customers.find(customerId => bookTask.customer?.id === customerId))
        );

        const cards = (<BookAppointmentsCards
            bookAppointmentTasks={filteredBookTasks}
            onChooseAndBook={this.props.chooseAndBook}
        />);

        const filters = (
            <BookAppointmentFilters
                onFiltersChanged={this.onFiltersChanged}
            />);

        const panes = [
            {
                menuItem: "Clinics", render: () => {
                    return (<Calendar
                        showClinics
                        onAppointmentDrop={this.onAppointmentDrop}
                        onHourDrop={this.onHourDrop}
                        onHourClick={this.onHourClick}
                        onAppointmentClick={this.onAppointmentClick}
                        showOnlyClinicsWithInsufficientClinicians={this.props.calendarFilters.showOnlyClinicsWithInsufficientClinicians}
                        onShowOnlyClinicsWithInsufficientCliniciansChanged={this.props.showOnlyClinicsWithInsufficientCliniciansChanged}
                        clinicLocationType={this.props.calendarFilters.clinicLocationType}
                        onClinicLocationTypeChanged={this.props.clinicLocationTypeChanged}
                        clinicType={this.props.calendarFilters.clinicType}
                        onClinicTypeChanged={this.props.clinicTypeChanged}
                        focusDate={this.props.calendarFilters.focusDate}
                        onDateChange={this.props.dateChanged}
                        selectedUserIds={this.props.calendarFilters.selectedUserIds}
                        onSelectedUserIdsChanged={this.props.selectedUserIdsChanged}
                        selectedRoomIds={this.props.calendarFilters.selectedRoomIds}
                        onSelectedRoomIdsChanged={this.props.selectedRoomIdsChanged}
                        showAppointmentCount={true}
                        showAllUsersOption={true}
                        showGapsAndClinicsFilters={true}
                    />);
                }
            },
            {
                menuItem: "Rooms and Clinicians", render: () => {
                    return (<Calendar
                        showClinics={false}
                        onAppointmentDrop={this.onAppointmentDrop}
                        onHourDrop={this.onHourDrop}
                        onHourClick={this.onHourClick}
                        onAppointmentClick={this.onAppointmentClick}
                        showOnlyClinicsWithInsufficientClinicians={this.props.calendarFilters.showOnlyClinicsWithInsufficientClinicians}
                        onShowOnlyClinicsWithInsufficientCliniciansChanged={this.props.showOnlyClinicsWithInsufficientCliniciansChanged}
                        clinicLocationType={this.props.calendarFilters.clinicLocationType}
                        onClinicLocationTypeChanged={this.props.clinicLocationTypeChanged}
                        clinicType={this.props.calendarFilters.clinicType}
                        onClinicTypeChanged={this.props.clinicTypeChanged}
                        focusDate={this.props.calendarFilters.focusDate}
                        onDateChange={this.props.dateChanged}
                        selectedUserIds={this.props.calendarFilters.selectedUserIds}
                        onSelectedUserIdsChanged={this.props.selectedUserIdsChanged}
                        selectedRoomIds={this.props.calendarFilters.selectedRoomIds}
                        onSelectedRoomIdsChanged={this.props.selectedRoomIdsChanged}
                        showAllUsersOption={true}
                        showGapsAndClinicsFilters={true}
                    />);
                }
            }
        ];

        return (
            <TriageList cards={cards} filter={filters} className="book-appointments-list">
                <Fragment forRoute="/appointment/:appointmentId/:customerId/:ohCaseId" withConditions={this.isTaskRoute}>
                    <TaskActionSubRoutes />
                </Fragment>
                <Fragment forRoute="/mergedappointment/:appointmentId/:customerId/:ohCaseId">
                    <MergedAppointmentModal onModalClose={this.onAppointmentModalClose} />
                </Fragment>
                <Fragment forRoute="/:bookTaskId/create-appointment">
                    <BookAdHocAppointment />
                </Fragment>
                <Fragment forRoute="/:bookTaskId/:clinicId/book-clinic-appointment">
                    <BookClinicAppointment />
                </Fragment>
                <Fragment forRoute="/:bookTaskId/:clinicId/open-clinic-appointments">
                    <BookMultipleAppointments onModalClose={this.onAppointmentModalClose} loadTasks={this.loadTasks} />
                </Fragment>
                <Fragment forRoute="/create-time-note">
                    <CreateTimeNoteModal />
                </Fragment>
                <Fragment forRoute="/" withConditions={this.isNotTaskRoute}>
                    <>
                        <Authorize authorize={[ADMIN_ROLES.ADMINISTRATOR.name, ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name]}>
                            <Dropdown className="icon create-button" labeled button text="Create" icon="add" direction="left">
                                <Dropdown.Menu>
                                    <Dropdown.Item as={Link} text="Create Clinic" href={`${this.props.path}/create`} />
                                    <Dropdown.Item as={Link} text="Create Mobile Clinic" href={`${this.props.path}/create-mobile-clinic`} />
                                </Dropdown.Menu>
                            </Dropdown>
                        </Authorize>
                        <Tab panes={panes} />
                        <AppointmentModal onModalClose={this.onAppointmentModalClose} />
                        <LocationTypeSelectorModal
                            {...this.state.locationTypeSelectorModal}
                            onCancel={() => this.setState({ locationTypeSelectorModal: { ...this.state.locationTypeSelectorModal, open: false } })}
                            onSubmit={this.onSubmitLocationTypeSelectorModal}
                        />
                    </>
                </Fragment>
            </TriageList>
        );
    }

    private onAppointmentDrop = (bookTaskId: string, appointment: AppointmentAndParent) => {
        const bookTask = this.props.bookAppointmentTasks.find(t => t.id === bookTaskId);
        if (!this.bookTaskCaseTypeMatchesAppointmentClinicTypeOrIsOpenClinic(bookTask.caseType, appointment)) {
            toast.error(`This clinic does not accept ${bookTask.caseType} appointments`);
            return;
        }
        if (this.isRestrictedByCustomerId(appointment.parentAppointment, bookTask)) {
            const customerName = this.props.customers.find(c => c.id === bookTask.customer?.id)?.name;
            toast.error(`This clinic does not accept appointments for customer ${customerName}`);

            const customerIds = appointment.parentAppointment.customerIds ?? [];
            const allowableCustomersNames = getCustomerNamesForBookableCustomerIds(customerIds, this.props.customers);
            toast.info(`This clinics accepts appointments for the following customers: ${allowableCustomersNames}`);

            return;
        }
        if (appointment.parentAppointment && !bookTask.locationType && appointment.clinicLocationTypes.length > 1) {
            this.setState({ locationTypeSelectorModal: { open: true, bookAppointmentTask: bookTask, appointment } });
            return;
        }

        const isFaceToFaceTaskTypeBookableIntoMobileClinic =
            FaceToFaceTaskTypesBookableIntoMobileClinic.includes(bookTask.type) &&
            appointment.clinicLocationTypes.includes(ClinicLocationTypeName.mobile);
        if (!isFaceToFaceTaskTypeBookableIntoMobileClinic &&
            bookTask.locationType && !appointment.clinicLocationTypes.find(l => bookTask.locationType === l)) {
            toast.error(`This clinic does not accept ${bookTask.locationType} appointments`);
            return;
        }
        if (appointment.parentAppointment) {
            this.props.bookIntoClinic(bookTaskId, appointment, bookTask.locationType ?? appointment.clinicLocationTypes[0]);
            return;
        }
        if (appointment.clinicLocationTypes.includes(ClinicLocationTypeName.mobile)) {
            this.props.bookIntoMobileClinic(bookTaskId, appointment);
            return;
        }

        this.props.bookIntoOpenClinic(bookTaskId, appointment);
    };

    private bookTaskCaseTypeMatchesAppointmentClinicTypeOrIsOpenClinic(bookTaskCaseType: string, appointment: AppointmentAndParent) {
        const openOrBookTaskCaseType = ["Open", bookTaskCaseType];
        return openOrBookTaskCaseType.find(type => type === appointment.clinicType || type === appointment.parentAppointment?.clinicType);
    }

    private onHourDrop = (bookTaskId: string, hour: moment.Moment, entityId: string) => {
        // If the calendar view is clinics then the entity id will be the clinic id and will not apply to an adhoc appointment
        if (this.state.calendarView === "clinics") {
            this.props.bookAdHocAppointment(bookTaskId, hour);
        } else {
            this.props.bookAdHocAppointment(bookTaskId, hour, entityId);
        }
    };

    private isTaskRoute = (l: Location) => !!l.params && !!l.params.taskId;

    private isNotTaskRoute = (l: Location) => !!l.params && !l.params.taskId;

    private isRestrictedByCustomerId = (parentAppointment: Clinic, bookTask: BookAppointmentTaskListModel) => {
        const customerIds = parentAppointment?.customerIds ?? [];
        const canBeBooked = customerIds.length === 0 || customerIds.includes(bookTask.customer.id) || customerIds.includes(ALL_CUSTOMERS);
        return !canBeBooked;
    };

    private onHourClick = (hour: moment.Moment, entityId: string) => {
        this.props.createTimeNoteAppointment(hour, entityId);
    };

    private onAppointmentClick(appointment: Appointment) {
        if (!appointment.clinicType) {
            this.props.selectAppointment(appointment);
        }
    }

    private onAppointmentModalClose() {
        this.props.closeAppointment();
    }

    private onFiltersChanged = (filters: BookAppointmentFiltersModel) => {
        this.setState({ filters }, this.loadTasks);
    };
}

const mapStateToProps = (state: ApplicationState): StateProps => {
    const bookTaskId = state.router.query.bookTaskId;
    return {
        bookAppointmentTasks: state.bookAppointments.bookAppointmentTasks.filter(t => !bookTaskId || t.id === bookTaskId),
        path: state.router.pathname,
        calendarFilters: state.bookAppointments.calendarFilters,
        bookTaskId,
        customers: state.customers,
        teams: state.teams
    };
};

const mapDispatchToProps = (dispatch: any): PropsFromDispatch => ({
    bookIntoClinic: (bookTask: BookAppointmentTaskListModel, appointment: AppointmentAndParent, locationType: ClinicLocationTypeName) => {
        dispatch(bookIntoClinic(bookTask, appointment, locationType));
    },
    bookIntoMobileClinic: (bookTask: BookAppointmentTaskListModel, appointment: AppointmentAndParent) => {
        dispatch(bookIntoMobileClinic(bookTask, appointment));
    },
    bookIntoOpenClinic: (path: string, bookTask: BookAppointmentTaskListModel, appointment: AppointmentAndParent) => {
        if (appointment.clinicType === "Health Surveillance")
        {
            dispatch(push(`${path}/${bookTask.id}/${appointment.id}/book-clinic-appointment`, { persistQuery: true }));
            return;
        }

        dispatch(push(`${path}/${bookTask.id}/${appointment.id}/open-clinic-appointments`, { persistQuery: true }));
    },
    bookAdHocAppointment: (path: string, bookTaskId: string, time: moment.Moment, clinicianId?: string) =>
        dispatch(push(
            { pathname: `${path}/${bookTaskId}/create-appointment`, query: { time: time.format(moment.HTML5_FMT.DATETIME_LOCAL), clinicianId } },
            { persistQuery: true }
        )),
    createTimeNoteAppointment: (path: string, time: moment.Moment, clinicianId: string) =>
        dispatch(push({ pathname: `${path}/create-time-note`, query: { time: time.format(moment.HTML5_FMT.DATETIME_LOCAL), clinicianId } })),
    closeAppointment: () => dispatch(push("/book-appointments")),
    selectAppointment: (appointment: AppointmentAndParent) => {

        if (appointment?.parentAppointment?.clinicType === "Open" && appointment?.baseAppointment) {
            dispatch(push(`/book-appointments/mergedappointment/${appointment.id}/${appointment.customer.id}/${appointment.ohCaseId}`));
            return;
        }

        if (appointment && appointment.customer && appointment.customer.id && appointment.ohCaseId)
        {
            dispatch(push(`/book-appointments/appointment/${appointment.id}/${appointment.customer.id}/${appointment.ohCaseId}`));
            return;
        }

        if (appointment.parentAppointment) {
            dispatch(push(`/book-appointments/clinic/${appointment.parentAppointment.id}/appointment/${appointment.id}`));
            return;
        }

        dispatch(push(`/book-appointments/appointment/${appointment.id}`));
    },
    showOnlyClinicsWithInsufficientCliniciansChanged: (showOnlyClinicsWithInsufficientClinicians: boolean) =>
        dispatch(showOnlyClinicsWithInsufficientCliniciansChanged(showOnlyClinicsWithInsufficientClinicians)),
    clinicTypeChanged: (clinicType: string) =>
        dispatch(clinicTypeChanged(clinicType)),
    clinicLocationTypeChanged: (clinicLocationType: ClinicLocationTypeName) =>
        dispatch(clinicLocationTypeChanged(clinicLocationType)),
    dateChanged: (date: moment.Moment) =>
        dispatch(focusDateChanged(date)),
    selectedUserIdsChanged: (userIds: string[]) =>
        dispatch(selectedUserIdsChanged(userIds)),
    selectedRoomIdsChanged: (roomIds: string[]) =>
        dispatch(selectedRoomIdsChanged(roomIds)),
    chooseAndBook: (task) => dispatch(chooseAndBook(task)),
    loadBookAppointmentTasks: (customerIds: string[], taskTypes: string[], caseTypes: CaseType[], bookTaskId: string, teamIds: string[]) =>
        dispatch(loadBookAppointmentTasks(customerIds, taskTypes, caseTypes, bookTaskId, teamIds)),
    loadCustomers: () => dispatch(loadCustomers())
});

const mergeProps = (stateProps: StateProps, propsFromDispatch: PropsFromDispatch): AllProps => {
    const dispatchBookIntoAppointment = (bookTaskId: string, appointment: AppointmentAndParent, locationType: ClinicLocationTypeName) =>
        propsFromDispatch.bookIntoClinic(stateProps.bookAppointmentTasks.find(bookTask => bookTask.id === bookTaskId), appointment, locationType);
    const dispatchBookIntoMobileClinic = (bookTaskId: string, appointment: Appointment) =>
        propsFromDispatch.bookIntoMobileClinic(stateProps.bookAppointmentTasks.find(bookTask => bookTask.id === bookTaskId), appointment);
    const dispatchBookIntoOpenClinic = (bookTaskId: string, appointment: Appointment) =>
        propsFromDispatch.bookIntoOpenClinic(stateProps.path, stateProps.bookAppointmentTasks.find(bookTask => bookTask.id === bookTaskId), appointment);
    const bookAdHocAppointment = (bookTaskId: string, time: moment.Moment, clinicianId: string) =>
        propsFromDispatch.bookAdHocAppointment(stateProps.path, bookTaskId, time, clinicianId);
    const createTimeNoteAppointment = (time: moment.Moment, clinicianId: string) =>
        propsFromDispatch.createTimeNoteAppointment(stateProps.path, time, clinicianId);
    return {
        ...stateProps,
        ...propsFromDispatch,
        bookAdHocAppointment,
        createTimeNoteAppointment,
        bookIntoOpenClinic: dispatchBookIntoOpenClinic,
        bookIntoMobileClinic: dispatchBookIntoMobileClinic,
        bookIntoClinic: dispatchBookIntoAppointment
    };
};

/**
 * @deprecated Replaced by BookAppointmentsList when FeatureToggleNames.EnableBookAppointmentsPageImprovements is toggled on
 */
export const OldBookAppointmentsList = connect(mapStateToProps, mapDispatchToProps, mergeProps)(BookAppointmentsListUnconnected);
